/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Checkbox, FormControlLabel, Grid, Link,
} from '@mui/material';
import { Field } from 'react-final-form';

export default function Toc({ params }) {
  return (
    <Grid container spacing={2} sx={{ marginTop: '20px' }}>
      <Field
        name="agb"
        type="checkbox"
        render={({ input }) => (
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox />}
              required
              label={(
                <span>
                  Ich habe die
                  {' '}
                  <Link href={params.link} target="_blank">Datenschutzerklärung</Link>
                  {' '}
                  gelesen und akzeptiere sie.
                </span>
              )}
              sx={{ marginTop: '7px', marginLeft: 0 }}
              {...input}
            />
          </Grid>
        )}
      />
      {/* <Field
        name="wiederruf"
        type="checkbox"
        render={({ input }) => (
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox />}
              required
              label="Die Widerrufsinformationen habe ich zur Kenntnis genommen."
              sx={{ marginTop: '7px', marginLeft: 0 }}
              {...input}
            />
          </Grid>
        )}
      /> */}
    </Grid>
  );
}
